import {
  developedByIcon,
  metaRatingsArrow,
  updatedEveryPatchIcon,
} from "@/designSystemIcons";
import { cn } from "@/lib/utils";
import { BREAKPOINTS } from "@/settings";
import { useTranslation } from "@repo/shared/i18n";
import { NavLink } from "react-router";
import { useMediaQuery } from "usehooks-ts";

const LAST_UPDATED = "Oct 8, 2026";

const MetaRatingInfoBanner = () => {
  const { t } = useTranslation(["metaRating", "common"]);
  const isTouch = useMediaQuery(BREAKPOINTS.TOUCH_DEVICE.query);
  return (
    <div
      className={cn(
        "py-10 bg-panel-background flex items-center justify-between gap-20",
        isTouch ? "p-6" : "px-20",
      )}
    >
      <div
        className={cn(
          "flex justify-between w-full max-w-[1376px] mx-auto",
          isTouch && "justify-center",
        )}
      >
        {!isTouch && (
          <div className={cn("flex flex-col", isTouch ? "w-full" : "w-5/12")}>
            <span className="text-xl font-bold text-dark-primary">
              {t("infoBanner.title")}
            </span>
            <span className="text-sm text-dark-tertiary">
              {t("hero.description")}
            </span>
          </div>
        )}

        <div
          className={cn(
            "w-auto flex gap-6 justify-end items-center",
            isTouch && "gap-6",
          )}
        >
          <div className={cn("flex gap-3")}>
            {!isTouch && <div>{developedByIcon}</div>}
            <div className={cn("flex flex-col", isTouch && "items-center")}>
              <div
                className={cn("text-sm font-semibold", isTouch && "text-xs")}
              >
                {t("infoBanner.madeBy")}
              </div>
              <div
                className={cn("text-sm font-semibold", isTouch && "text-xs")}
              >
                {t("infoBanner.developedWith")}
              </div>
              <a
                className="text-[#4DC6ED] flex gap-0.5 items-center text-xs touch-device:text-sm cursor-pointer"
                href={"https://www.youtube.com/watch?v=fC2vy6uFlCg&t=1s"}
                target="_blank"
                rel="noopener noreferrer"
              >
                {t("common:learnMore")} {metaRatingsArrow}
              </a>
            </div>
          </div>

          <div className={cn("flex gap-3")}>
            {!isTouch && <div>{updatedEveryPatchIcon}</div>}
            <div className={cn("flex flex-col", isTouch && "items-center")}>
              <div
                className={cn("text-sm font-semibold", isTouch && "text-xs")}
              >
                {t("infoBanner.updatedEveryPatch")}
              </div>
              <div
                className={cn(
                  "text-sm font-semibold italic text-dark-secondary",
                  isTouch && "text-xs",
                )}
              >
                {t("infoBanner.lastUpdated", { date: LAST_UPDATED })}
              </div>
              <NavLink
                className="text-[#4DC6ED] flex gap-0.5 items-center text-sm cursor-pointer"
                to={"/news/ea-fc-27-meta-rating-update-1"}
                state={{ from: "/meta-rating" }}
              >
                {t("infoBanner.patchNotes")} {metaRatingsArrow}
              </NavLink>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MetaRatingInfoBanner;
